import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'BackgroundLayer',
	loadComponent: () => import('./BackgroundLayer' /* webpackChunkName: "BackgroundLayer" */),
}

export default entry
